import React from "react";
import {Button} from "react-bootstrap";
import {BsInfoCircle} from "react-icons/bs";

interface LegendInfoButtonProps {
  showLegend: boolean;
  onToggle: () => void;
}

const LegendInfoButton = ({showLegend, onToggle}: LegendInfoButtonProps) => {
  return (
    <Button
      variant="outline-light"
      active={showLegend}
      aria-label="Legend"
      aria-expanded={showLegend}
      title="Legend"
      onClick={onToggle}>
      <BsInfoCircle className="ui-icon"/>
    </Button>
  );
};

export default LegendInfoButton;
